import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "D:/Documents/React Projects/components/react-mui-draft-wysiwyg/node_modules/gatsby-theme-docz/src/base/Layout.js";
import MUIEditor, { MUIEditorState } from "../../src";
import { convertToRaw } from 'draft-js';
import { Playground } from "docz";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <blockquote>
      <p parentName="blockquote">{`This example shows how to save the editor content for example to a server.`}</p>
    </blockquote>
    <h2 {...{
      "id": "imports"
    }}>{`Imports`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`import MUIEditor, { MUIEditorState } from "react-mui-draft-wysiwyg";
import { convertToRaw } from 'draft-js';
`}</code></pre>
    <p>{`More info for `}<inlineCode parentName="p">{`convertToRaw`}</inlineCode>{`:`}</p>
    <p><a parentName="p" {...{
        "href": "https://draftjs.org/docs/api-reference-data-conversion/#converttoraw"
      }}>{`https://draftjs.org/docs/api-reference-data-conversion/#converttoraw`}</a></p>
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <Playground __position={0} __code={'() => {\n  const editorConfig = {}\n  const [editorState, setEditorState] = React.useState(\n    MUIEditorState.createEmpty(editorConfig),\n  )\n  const onChange = newState => {\n    setEditorState(newState)\n  }\n  const save = () => {\n    const rawContent = convertToRaw(editorState.getCurrentContent())\n    // Here you can send the rawContent object to a server or whatever you want\n    console.log(rawContent)\n    alert(\'Saved\')\n  }\n  return (\n    <>\n      <MUIEditor\n        editorState={editorState}\n        onChange={onChange}\n        config={editorConfig}\n      />\n      <button onClick={save} type=\"button\">\n        Save\n      </button>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      MUIEditor,
      MUIEditorState,
      convertToRaw,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const editorConfig = {};
        const [editorState, setEditorState] = React.useState(MUIEditorState.createEmpty(editorConfig));

        const onChange = newState => {
          setEditorState(newState);
        };

        const save = () => {
          const rawContent = convertToRaw(editorState.getCurrentContent()); // Here you can send the rawContent object to a server or whatever you want

          console.log(rawContent);
          alert('Saved');
        };

        return <>
        <MUIEditor editorState={editorState} onChange={onChange} config={editorConfig} mdxType="MUIEditor" />
        <button onClick={save} type="button">Save</button>
      </>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      